// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3534":"c1d31ca1","9491":"c00734bc"}[chunkId] + ".chunk.css";
};